import { createNamedContext } from '@core/createNamedContext'
import type { WebsiteConfig } from '@infrastructure/config/baseSchema'

// @TODO: refactor to parse and allow only specific vars
//        that are safe to be exposed in the client bundle
//        similar to the ENV's getClientEnvironmentVariables

export type ConfigContextValue = {
  showEditModuleLink: WebsiteConfig['showEditModuleLink']
  showModuleErrors: WebsiteConfig['showModuleErrors']
  showBelgium: WebsiteConfig['showBelgium']
  contentfulEnvironment: WebsiteConfig['contentful']['environment']
}

export const ConfigContext = createNamedContext<ConfigContextValue>(
  'ConfigContext',
  {
    showEditModuleLink: false,
    contentfulEnvironment: 'master',
    showModuleErrors: false,
    showBelgium: false,
  }
)
